import React from 'react';
import GroupsOverviewGrid from '../GroupsOverviewGrid/GroupsOverviewGrid';

function GroupsOverviewGridSmall(props) {
  return <GroupsOverviewGrid {...props} showImage={false} />;
}

export default GroupsOverviewGridSmall;
